import { render } from "./ComponentPaginacao.vue?vue&type=template&id=45a5eefe"
import script from "./ComponentPaginacao.vue?vue&type=script&lang=js"
export * from "./ComponentPaginacao.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__